import { createSlice } from "@reduxjs/toolkit";
import { CommonTableState, updateTableState } from "./general/commonTableSliceFeatures";

const initialState: CommonTableState = {
    tableState: {
        resetIndicator: 0,
        sorting: [{ id: "created", desc: true }],
        columnOrder: ["accountant.licence.company.id", "accountant.user.id","usageType", "monthlyDocuments", "created"],
        density: "compact",
    },
};

export const accountantOnboardingSlice = createSlice({
    name: "accountantOnboarding",
    initialState: initialState,
    reducers: {
        updateAccountantOnboardingTableState: (state, payload) => updateTableState(state, payload, initialState.tableState),
    },
});

export const { updateAccountantOnboardingTableState } = accountantOnboardingSlice.actions;

export default accountantOnboardingSlice.reducer;
